module.exports = __webpack_public_path__ + "img/Device-Attendance-Lit.3245e006.png";